import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Typography
} from '..';
// ----------------------------------------------------------------------

const ConfirmDialog = ({
  title,
  content,
  action,
  open,
  onClose,
  cancelText = 'Cancel',
  ...other
}: any) => {
  return (
    <Dialog fullWidth maxWidth='xs' open={open} onClose={onClose} {...other}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        {content && <Typography variant='body2'> {content} </Typography>}

        <DialogFooter>
          {action}

          <Button variant='outline' color='inherit' onClick={onClose}>
            {cancelText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDialog;
